module.exports = __webpack_public_path__ + "static/img/fu-footer.f96d9ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fu-footer.png
// module id = zSaM
// module chunks = 0